
import React from 'react';
import FormInput from '../FormInput';
import { CampaignOutcome } from '../../types';

interface CampaignOutcomeFormProps {
  data: CampaignOutcome;
  onChange: (field: string, value: string) => void;
  errors: Record<string, string>;
}

const CampaignOutcomeForm: React.FC<CampaignOutcomeFormProps> = ({
  data,
  onChange,
  errors
}) => {
  return (
    <div className="animate-fade-in">
      <h3 className="text-lg font-medium mb-4">Winning Aspiration & Success Metrics</h3>
      
      <FormInput
        id="winning_aspiration"
        label="What does winning look like for this campaign?"
        placeholder="e.g., secure policy change, win electoral commitment, achieve funding increase"
        value={data.winning_aspiration}
        onChange={(e) => onChange('winning_aspiration', e.target.value)}
        required
        error={errors['campaign_outcome.winning_aspiration']}
      />
      
      <FormInput
        id="success_metrics"
        label="How will you measure success?"
        placeholder="e.g., specific vote outcomes, policy commitments, funding amounts, endorsements"
        value={data.success_metrics}
        onChange={(e) => onChange('success_metrics', e.target.value)}
        multiline
        rows={3}
        required
        error={errors['campaign_outcome.success_metrics']}
      />
      
      <FormInput
        id="target_audience"
        label="Who is your primary target audience?"
        placeholder="e.g., government ministers, swing voters, coalition partners, media"
        value={data.target_audience}
        onChange={(e) => onChange('target_audience', e.target.value)}
        required
        error={errors['campaign_outcome.target_audience']}
      />
    </div>
  );
};

export default CampaignOutcomeForm;
